<div *ngIf="state === 'loading'" class="text-muted m-b-sm" test-id="placeholdersMatching">
  <em class="fa fa-light fa-spinner fa-spin"></em>
  <span class="m-l-sm">{{ 'TEMPLATE.ai_review_matching' | translate }}</span>
</div>

<gp-message *ngIf="state === 'failed'"
            [text]="'TEMPLATE.ai_field_resolution_failed' | translate"
            test-id="placeholdersMatchFailed"
            type="warning">
</gp-message>

<ng-container *ngIf="rows?.length">
  <div class="placeholders-help">
    <p class="text-sm text-muted">{{ 'TEMPLATE.ai_review_help' | translate }}</p>
    <button (click)="refresh.emit()"
            [attr.aria-label]="'TEMPLATE.ai_review_refresh' | translate"
            [disabled]="state === 'loading'"
            [title]="'TEMPLATE.ai_review_refresh' | translate"
            class="btn btn-icon btn-xs"
            test-id="btnRefreshPlaceholders"
            type="button">
      <em aria-hidden="true" class="fa fa-light fa-sync"></em>
    </button>
  </div>
  <gp-field-review-list (locate)="locate.emit($event)"
                        (rowsChange)="rowsChange.emit($event)"
                        [fieldTree]="fieldTree"
                        [rows]="rows">
  </gp-field-review-list>
</ng-container>

<div *ngIf="canMatch || rows?.length" class="placeholders-footer btn-bar btn-bar-sm btn-bar-align-end">
  <button (click)="matchWithAi.emit()"
          *ngIf="canMatch"
          [disabled]="state === 'loading'"
          class="btn btn-sm btn-outline b-primary text-primary"
          test-id="btnMatchWithAi"
          type="button">
    <em aria-hidden="true" class="fa fa-light fa-wand-magic-sparkles m-r-xs"></em>
    {{ 'TEMPLATE.ai_review_match_with_ai' | translate }}
  </button>
  <button (click)="apply.emit(approvedRows)"
          *ngIf="rows?.length"
          [disabled]="!approvedRows.length"
          class="btn btn-primary btn-sm"
          test-id="btnApplyFieldReview"
          type="button">
    {{ 'TEMPLATE.ai_review_apply' | translate: {count: approvedRows.length} }}
  </button>
</div>
